import { Divider } from '@knack/asterisk-react';

import { FieldSettings } from '@/components/field-settings/FieldSettings';
import { MainLayout } from '@/components/layout/MainLayout';

export function SettingsPage() {
  return (
    <MainLayout>
      <h1>Settings</h1>
      {/**/}
      <FieldSettings objectKey="object_1" fieldId="field_51" closeFieldSettings={() => {}} />
      <Divider className="mb-5" />
      {/* This is used when you know the type */}
      <FieldSettings objectKey="object_1" initialType="number" closeFieldSettings={() => {}} />
      <Divider className="mb-5" />
      {/* This is for creation (no fieldId assigned yet) */}
      <FieldSettings objectKey="object_1" closeFieldSettings={() => {}} />
    </MainLayout>
  );
}
